if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.minicart = document.querySelector('mini-cart');
        this.eventContext = this.form.dataset.eventContext;
        this.hideErrors = this.dataset.hideErrors === 'true';
        this.selectedVariant = this.form.querySelector('[name=id]').value;
      }

      onSubmitHandler(event) {
        event.preventDefault();
        const submitButton = this.querySelector('[type="submit"]');
        if (submitButton.classList.contains('loading')) {
          return;
        }

        this.handleErrorMessage();

        submitButton.setAttribute('aria-disabled', true);
        submitButton.classList.add('loading');
        this.querySelector('.button-overlay-spinner').classList.remove(
          'hidden'
        );

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';

        let formData = {
          items: [
            {
              id: this.form.querySelector('[name=id]').value,
              quantity: Number(
                this.form.querySelector('[name=quantity]').value
              ),
            },
          ],
        };

        let complimentaryProducts = document.querySelectorAll('[name="complimentary_product"]:checked');
        if( complimentaryProducts.length > 0 ) {
          complimentaryProducts.forEach((element) => {
            formData.items.push({ id: element.dataset.variantId, quantity: 1 });
          });
        }

        formData.sections = this.minicart
          .getSectionsToRender()
          .map((section) => section.id);
        formData.sections_url = window.location.pathname;

        config.body = JSON.stringify(formData);

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                errors: response.errors || response.description,
                message: response.message,
              });

              this.handleErrorMessage(response.description);
              return;
            }

            this.minicart.renderContents(response);

            if (window.Rebuy && window.Rebuy.SmartCart && window.Rebuy.SmartCart.status === 'ready') {
              Rebuy.SmartCart.show()
            } else if (window.themeSettings.redirectToCart) {
              location.href = '/cart';
            } else {
              this.minicart.open(submitButton);
            }

            const event = new CustomEvent('cart:item-add', {
              detail: {
                items: [response],
                context: this.eventContext,
              },
            });
            document.dispatchEvent(event);

            publish(PUB_SUB_EVENTS.cartItemAdd, {
              source: this.eventContext,
              items: [response],
            });
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            submitButton.classList.remove('loading');
            submitButton.removeAttribute('aria-disabled');
            this.querySelector('.button-overlay-spinner').classList.add(
              'hidden'
            );
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) {
          return;
        }

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector('.product-form-error-message-wrapper');
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector('.product-form-error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
